import {
  CommonTextInputField,
  RepeatableTwoInputswithImage,
  RepeatableTwoTextInputFields,
} from "@/components";
import React from "react";

const ServiceResourcesFieldSection = ({
  control,
  errors,
  formData,
  filesList,
  allFiles,
  paginationDetails,
  handleAddRepeatableField,
  handleOnChangeRepeatableFields,
  handleRemoveRepeatableField,
  adminRole,
  permissionsList,
  searchValue,
  selectedFileType,
  isItemDetailsExist = false,
  isHideInOtherLanguages = false,
}) => {
  return (
    <>
      {/* Service Registration Resources Heading */}
      <CommonTextInputField
        fieldName="service_registration_resources_heading"
        fieldType="text"
        fieldId={
          isItemDetailsExist
            ? "service-update-registration-resources-heading"
            : "service-registration-resources-heading"
        }
        control={control}
        errors={errors}
        errorsType={errors?.service_registration_resources_heading}
        placeholderText="Registration Heading"
        labelName="Registration Heading"
        inputBoxMaxWidth="xl:max-w-[500px]"
        translateField={isItemDetailsExist}
      />

      {/* Service Registration Resources Button Label */}
      <CommonTextInputField
        fieldName="service_registration_resources_button_label"
        fieldType="text"
        fieldId={
          isItemDetailsExist
            ? "service-update-registration-resources-button-label"
            : "service-registration-resources-button-label"
        }
        control={control}
        errors={errors}
        errorsType={errors?.service_registration_resources_button_label}
        placeholderText="Registration Button Label"
        labelName="Registration Button Label"
        inputBoxMaxWidth="xl:max-w-[500px]"
        extraClass="mt-5"
        translateField={isItemDetailsExist}
      />

      {/* Service Registration Resources */}
      <RepeatableTwoTextInputFields
        formData={formData}
        labelText="Registration Resources"
        fieldId={
          isItemDetailsExist
            ? "service-update-registration-resources"
            : "service-registration-resources"
        }
        translateField={isItemDetailsExist}
        repeatableKeyname="service_registration_resources"
        repeatableKeys={["resources", "names"]}
        addNewField={handleAddRepeatableField}
        removeField={handleRemoveRepeatableField}
        onChangeField={handleOnChangeRepeatableFields}
        firstInputFieldPlaceholder="Resource Link"
        secondInputFieldPlaceholder="Name"
        firstInputFieldExtraInfo="Provide valid full resource link"
        secondInputFieldExtraInfo=""
        firstInputHideStatus={isHideInOtherLanguages}
        secondInputHideStatus={true}
        extraContainerClasses="mt-5"
        inputBoxMaxWidth="xl:max-w-[500px]"
      />

      {/* Separator Line */}
      <div className="w-full border border-dashed border-[#000]/20 dark:border-[#fff]/10 my-10" />

      {/* Service Downloads Resources Heading */}
      <CommonTextInputField
        fieldName="service_download_resources_heading"
        fieldType="text"
        fieldId={
          isItemDetailsExist
            ? "service-update-download-resources-heading"
            : "service-download-resources-heading"
        }
        control={control}
        errors={errors}
        errorsType={errors?.service_download_resources_heading}
        placeholderText="Download Heading"
        labelName="Download Heading"
        inputBoxMaxWidth="xl:max-w-[500px]"
        translateField={isItemDetailsExist}
      />

      {/* Service Downloads Resources Button Label */}
      <CommonTextInputField
        fieldName="service_download_resources_button_label"
        fieldType="text"
        fieldId={
          isItemDetailsExist
            ? "service-update-download-resources-button-label"
            : "service-download-resources-button-label"
        }
        control={control}
        errors={errors}
        errorsType={errors?.service_download_resources_button_label}
        placeholderText="Download Button Label"
        labelName="Download Button Label"
        inputBoxMaxWidth="xl:max-w-[500px]"
        extraClass="mt-5"
        translateField={isItemDetailsExist}
      />

      {/* Service Download Resources */}
      <RepeatableTwoTextInputFields
        formData={formData}
        labelText="Download Resources"
        fieldId={
          isItemDetailsExist
            ? "service-update-download-resources"
            : "service-download-resources"
        }
        translateField={isItemDetailsExist}
        repeatableKeyname="service_download_resources"
        repeatableKeys={["resources", "names"]}
        addNewField={handleAddRepeatableField}
        removeField={handleRemoveRepeatableField}
        onChangeField={handleOnChangeRepeatableFields}
        firstInputFieldPlaceholder="Resource Link"
        secondInputFieldPlaceholder="Name"
        firstInputFieldExtraInfo="Provide valid full resource link"
        secondInputFieldExtraInfo=""
        firstInputHideStatus={isHideInOtherLanguages}
        secondInputHideStatus={true}
        extraContainerClasses="mt-5"
        inputBoxMaxWidth="xl:max-w-[500px]"
      />
    </>
  );
};

export default ServiceResourcesFieldSection;
